/*
 * IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA
 * GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT
 *
 * Copyright: 2023 by Idemia Identity & Security USA LLC. All rights reserved.
 * License: In accordance  Idemia I&S USA LLC's license agreement.
 * Code Classification: GOVERNMENT
 *
 * Classification Person: Nadim Bakizada nadim.bakizada@us.idemia.com
 * Classification Reason: Software not specific to any U.S. Government Entity
 * Classification Date: 2023
 *
 * GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT
 * IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA
 */

import { useState, useEffect } from "react";
import { useTableStore } from "state";

export const useSetPagination = (tableName: string) => {
    const [page, setPage] = useState()
    const [rowsPerPage, setRowsPerPage] = useState()
    const pagination = useTableStore(state => state.pagination)

    useEffect(() => {
        if (pagination.hasOwnProperty(tableName)) {
            const { page, rowsPerPage } = pagination[tableName]
            setPage(page)
            setRowsPerPage(rowsPerPage)
        }
    }, [pagination])

    return { page, rowsPerPage }
}